<template>
  <div>
    <el-form 
      :model="info" 
      :rules="rules" 
      ref="form" 
      label-width="110px"
    >
      <el-form-item label="姓名" prop="nomDest">
        <el-autocomplete
          v-model.number="info.nomDest"
          :fetch-suggestions="getAddress"
          placeholder="可检索"
          style="width: 100%"
          @select="handleAddress"
          clearable
        >
          <template slot-scope="{ item }">
            <div style="padding:10px 0">
              <div style="line-height: 20px; text-overflow: ellipsis;overflow: hidden;">
                {{ item.nomDest }} {{ item.telefDest }}
              </div>
              <div style="line-height: 20px; text-overflow: ellipsis;overflow: hidden; color:#b4b4b4; font-size:12px;">
                {{ item.pobDest }} {{ item.dirDest }}
              </div>
            </div>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="电话" prop="telefDest">
        <el-input v-model="info.telefDest" clearable></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="dirDest">
        <el-autocomplete
          v-model.number="info.dirDest"
          :fetch-suggestions="getGoogleAddress"
          placeholder="可检索"
          style="width: 100%"
          @select="handleGoogleAddress"
          clearable
        >
          <template slot-scope="{ item }">
            <div style="padding:10px 0">
              <div style="line-height: 20px; text-overflow: ellipsis;overflow: hidden;">
                {{ item.address }}
              </div>
              <div style="line-height: 20px; text-overflow: ellipsis;overflow: hidden; color:#b4b4b4; font-size:12px;">
                {{ item.info }}
              </div>
            </div>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Localidad" prop="pobDest">
            <el-input v-model="info.pobDest" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮编" prop="codPosNacDest">
            <el-input v-model="info.codPosNacDest" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { address } from '../api/api';
import { googleAutoComplete, googleDetails } from '../google';

export default {
  name: 'HomeShou',
  data() {
    return {
      info: {
        nomDest: '',
        telefDest: '',
        pobDest: '',
        dirDest: '',
        codPosNacDest: ''
      },

      rules: {
        nomDest: [ { required: true, message: '请填写收件人姓名', trigger: 'change' } ],
        telefDest: [ { required: true, message: '请填写收件人电话', trigger: 'change' } ],
        pobDest: [ { required: true, message: '请填写收件人城市', trigger: 'change' } ],
        dirDest: [ { required: true, message: '请填写收件人地址', trigger: 'change' } ],
        codPosNacDest: [ { required: true, message: '请填写收件人邮编', trigger: 'change' } ]
      },
    }
  },
  methods: {
    getAddress(value, cb) {
      address(value, 1).then(res => {
        cb(res)
      })
    },
    handleAddress(addres) {
      // 获取规则的keys
      Object.keys(this.info).map((item) => {
        this.info[item] = addres[item]  
      })
    },
    getGoogleAddress(value, cb) {
      googleAutoComplete(value, res => {
        cb(res)
      })
    },
    handleGoogleAddress(addres) {
      googleDetails(addres.id, res => {
        this.info.dirDest = addres.address

        if(res.code) {
          this.info.codPosNacDest = res.code
        }
        if(res.city) {
          this.info.pobDest = res.city
        }
      })
    },
    // 设置
    set(data) {
      this.info = {
        nomDest: data.name,
        telefDest: data.tel,
        pobDest: data.pob,
        dirDest: data.dir,
        codPosNacDest: data.cod
      }
    },
    // 清空
    empty() {
      this.set({
        name: '',
        tel: '',
        pob: '',
        dir: '',
        cod: ''
      }, false)
    },
    async get() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            resolve(this.info) 
          } else {
            reject(false)
          }
        });
      });
    }
  },
}
</script>